import * as theme from "../theme";
import Button from "react-bootstrap/Button";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import _ from "lodash";

import PerfectScrollbar from "react-perfect-scrollbar";
import {
  getUserInformation,
  getUserDetails,
  getUpdateButtonStatus,
  toggleUpdateButton,
  geNewUserModelStatus,
  toggleNewUserModel,
  getUpdateUserModelStatus,
  toggleUpdateUserModel,
  selectUpdateUser,
  getUpdateUserSelected,
  updateDetails,
  addNewUser,
  getAllUsers,
  getAllUsersList,
  getUpdateErrors,
} from "../store/userManagement";
import { toast } from "react-toastify";
import ReactSelect from "react-select";
import {
  getBrokeragesList,
  loadBrokerages,
  brokerageSelected,
} from "../store/brokerages";
import Select from "react-dropdown-select";
import { SdCardSharp } from "@material-ui/icons";

import { useNavigate } from "react-router-dom";
import { sendSignupEmail, storeEmailId } from "../store/passwordManagement";

const BrokerageSuperAdminUserManagement = (props) => {
  const dispatch = useDispatch();

  let history = useNavigate();
  const [selectedCode, setSelectedCode] = useState(null);
  const [selectedAddressList, setSelectedAddressList] = useState(null);
  const brokerages = useSelector(getBrokeragesList);
  const [selectedBrokerageName, setSelectedBrokerageName] = useState(
    "Search for a brokerage"
  );
  useEffect(() => {
    dispatch(loadBrokerages());
  }, [dispatch]);

  useEffect(() => {
    if (
      !props.brokerageCode &&
      !selectedCode &&
      brokerages &&
      brokerages[0]?.code
    ) {
      dispatch(getUserDetails({ brokerage_code: brokerages[0]?.code }));
      setSelectedCode(brokerages[0].code);
      setSelectedBrokerageName(brokerages[0].name);
      setSelectedAddressList(brokerages[0].address);
    } else if (props.brokerageCode && brokerages) {
      for (let br of brokerages) {
        if (br.code == props.brokerageCode) {
          dispatch(getUserDetails({ brokerage_code: props.brokerageCode }));
          setSelectedCode(props.brokerageCode);
          setSelectedBrokerageName(br.name);
          setSelectedAddressList(br.address);
          break;
        }
      }
    }
  }, [brokerages]);

  const onChangeHandle = (value) => {
    if (value[0]?.code) {
      history("/quoteyadmin/user?c=" + encodeURIComponent(value[0].code));
      dispatch(getUserDetails({ brokerage_code: value[0].code }));
      setSelectedCode(value[0].code);
      setSelectedBrokerageName(value[0].name);
      setSelectedAddressList(value[0].address);
    }
  };

  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
        }}
      >
        <div
          style={{
            width: "80%",
            marginLeft: "10%",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <Select
            placeholder={selectedBrokerageName}
            color={theme.COLORS.primary_navyblue}
            searchable={true}
            onChange={(values) => onChangeHandle(values)}
            values={[]}
            options={brokerages}
            style={{
              width: "100%",
              height: "6vh",
              fontSize: "1.9vmin",
              border: "5px solid white",
              borderRadius: 15,
              fontFamily: "GibsonRegular",
            }}
            labelField={"name"}
            valueField={"code"}
            dropdownHeight={"58vh"}
          />
        </div>
      </div>
      <UserManagement
        brokerageCode={selectedCode}
        brokerageAddressList={selectedAddressList}
      ></UserManagement>
    </div>
  );
};

const UserManagement = (props) => {
  const isUpdateEnabled = useSelector(getUpdateButtonStatus);
  const dispatch = useDispatch();
  let data = { brokerage_code: props.brokerageCode };
  useEffect(() => {
    dispatch(getUserDetails(data));
  }, []);

  let userList = useSelector(getUserInformation);
  console.log(userList);
  const onUpdateChangeHandle = (value) => {
    dispatch(toggleUpdateButton(value));
  };

  const onNewUserModelChangeHandle = (value) => {
    dispatch(getAllUsers());
    dispatch(toggleNewUserModel(value));
  };

  const onUpdateUserModelChangeHandle = (value, user) => {
    dispatch(selectUpdateUser(user));
    dispatch(toggleUpdateUserModel(value));
  };

  return (
    <div className="m-4">
      <div className="d-flex">
        <div
          className="m-4"
          style={{
            width: "100%",
          }}
        >
          <div
            className="d-flex"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "1.2vw",
            }}
          >
            You can add, suspend and update contact details for users in your
            brokerage
          </div>

          <div
            className="d-flex m-2"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              paddingTop: "25px",
              fontSize: "0.8vw",
            }}
          >
            <table className="table  table-sm">
              <thead>
                <tr>
                  <th scope="col">User Name</th>
                  <th scope="col" className="text-center">
                    Admin
                  </th>
                  <th scope="col" className="text-center">
                    Active
                  </th>
                  <th scope="col">Email</th>
                  <th scope="col">Contact Number</th>
                  <th scope="col">Location</th>
                  <th scope="col" className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {userList.map((user, index) => {
                  let city = user?.location
                    ?? user?.brokerages?.[0]?.address?.[0]?.city
                    ?? user?.brokerages?.[0]?.address?.city
                    ?? "";
                  return (
                    <tr key={index}>
                      <td>{user.firstname + " " + user.lastname}</td>
                      <td className="text-center">
                        {user.isadmin ? <span>Yes</span> : <span>No</span>}
                      </td>
                      <td className="text-center">
                        {user.isactive ? <span>Yes</span> : <span>No</span>}
                      </td>
                      <td>{user.user.email}</td>
                      <td>{user.phonenumber}</td>
                      <td>{city}</td>
                      <td className="text-center">
                        <Button
                          style={{
                            color: "white",
                            height: "3.5vh",
                            fontFamily: "GibsonSemiBd",
                            fontSize: 12,
                            backgroundColor: theme.COLORS.secondary_skyblue,
                            border: 0,
                            width: "5vw",
                          }}
                          onClick={() => {
                            var tempUser = _.cloneDeep(user);
                            if (tempUser.location == null) {
                              tempUser["location"] = " ";
                            }
                            onUpdateUserModelChangeHandle(true, tempUser);
                          }}
                        >
                          Update
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div>
            <Button
              style={{
                color: "white",
                height: "4vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                border: 0,
                width: "10vw",
              }}
              onClick={() => onNewUserModelChangeHandle(true)}
            >
              Add a new user
            </Button>
          </div>
        </div>
      </div>
      <AddUserModal
        brokerageCode={props.brokerageCode}
        brokerageAddressList={props.brokerageAddressList}
      ></AddUserModal>
      <UpdateUserModal
        brokerageCode={props.brokerageCode}
        brokerageAddressList={props.brokerageAddressList}
      ></UpdateUserModal>
    </div>
  );
};

const AddUserModal = (props) => {
  const newUserModalState = useSelector(geNewUserModelStatus);

  return (
    <Modal
      size="md"
      isOpen={newUserModalState}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "65vh",
          width: "40vw",
          position: "absolute",
          top: "15vh",
          left: "25vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      <NewUser
        brokerageCode={props.brokerageCode}
        brokerageAddressList={props.brokerageAddressList}
      ></NewUser>
    </Modal>
  );
};

const NewUser = (props) => {
  const dispatch = useDispatch();
  let allUsers = useSelector(getAllUsersList);
  const updateErrors = useSelector(getUpdateErrors);
  const [newuser, setNewuser] = useState(null);
  const onUserSelection = (value) => {
    if (value[0]) {
      setNewuser(value[0].email);
    }
  };

  const onAddButtonClick = () => {
    let data = {
      firstname: name,
      email: email,
      password: password,
      phonenumber: phone,
      location: location,
      jobrole: role,
      bio: bio,
      isadmin: admin,
      isactive: active,
      brokeragecodes: [props.brokerageCode],
    };
    let code = { brokerage_code: props.brokerageCode };
    console.log(data);
    dispatch(addNewUser(data))
      .then(
        setTimeout(() => {
          dispatch(
            sendSignupEmail({
              emailid: data.email,
              frontEndOrigin: window.location.origin,
            })
          );
          dispatch(storeEmailId(data.email));
          dispatch(toggleNewUserModel(false));
        }, 100)
      )
      .then(
        setTimeout(() => {
          dispatch(getUserDetails(code));
          Array.isArray(updateErrors) && !updateErrors.length
            ? toast.success("New User Created")
            : toast(updateErrors);
        }, 1000)
      );
  };

  const onLocantionChangeHandler = (values) => {
    setLocation(values[0].value);
  };

  const [name, setName] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [active, setActive] = useState(true);
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);
  const [password, setPassword] = useState(null);
  const [location, setLocation] = useState(null);
  const [role, setJobRole] = useState(null);
  const [bio, setBio] = useState(null);
  return (
    <PerfectScrollbar>
      <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
        <div className="row ml-1 p-3">
          <div>
            <span
              className="text-center"
              style={{ fontFamily: "GibsonSemiBd", fontSize: "17px" }}
            >
              Add a new User
            </span>
          </div>

          <div
            className="ml-auto"
            style={{ marginTop: "-15px", marginRight: "-10px" }}
          >
            <CancelIcon
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => {
                dispatch(toggleNewUserModel(false));
              }}
            ></CancelIcon>
          </div>
        </div>

        <div
          className="row pt-3  justify-content-center"
          style={{
            fontFamily: "GibsonRegular",
          }}
        >
          <div className="col-10">
            <form noValidate>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Name</label>
                <div className="col-sm-9">
                  <input
                    required
                    autoFocus
                    type="text"
                    id="uName"
                    name="uName"
                    className="form-control"
                    placeholder="Enter Name"
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setName(event.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Password</label>
                <div className="col-sm-9">
                  <input
                    required
                    type="password"
                    id="uPass"
                    name="uPass"
                    className="form-control"
                    placeholder="Enter Temporary Password"
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setPassword(event.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Email</label>
                <div className="col-sm-9">
                  <input
                    required
                    type="email"
                    id="uEmail"
                    name="uEmail"
                    className="form-control"
                    placeholder="Enter Email"
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setEmail(event.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Contact</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    id="uContact"
                    name="uContact"
                    className="form-control"
                    placeholder="Enter Contact"
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setPhone(event.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Location</label>
                <div className="col-sm-9">
                  <Select
                    color={theme.COLORS.primary_navyblue}
                    options={props.brokerageAddressList.map(
                      ({ addr_line1, city, postal_code }) => ({
                        value: addr_line1 + " " + city + " " + postal_code,
                        label: addr_line1 + " " + city + " " + postal_code,
                      })
                    )}
                    onChange={(values) => onLocantionChangeHandler(values)}
                    style={{
                      width: "100%",
                      height: "6vh",
                      fontSize: "1.9vmin",
                      border: "5px solid white",
                      borderRadius: 15,
                      fontFamily: "GibsonRegular",
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Role/ Job Title
                </label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    id="role"
                    name="role"
                    className="form-control"
                    placeholder="Enter Job Title/Role"
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setJobRole(event.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Biography (max 250 chars)
                </label>
                <div className="col-sm-9">
                  <textarea
                    type="text"
                    id="biography"
                    name="biography"
                    rows="3"
                    className="form-control"
                    placeholder="Enter Biography (max 250 chars)"
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setBio(event.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 form-check-label">Admin</label>
                <div className="col-sm-9">
                  <input
                    className="form-check-input ml-0"
                    type="checkbox"
                    id="isUAdmin"
                    name="isUAdmin"
                    onChange={(event) => {
                      setAdmin(event.target.checked);
                    }}
                    style={{ backgroundColor: "#d6dae6" }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 form-check-label">Active</label>
                <div className="col-sm-9">
                  <input
                    className="form-check-input ml-0"
                    type="checkbox"
                    id="isUActive"
                    name="isUActive"
                    defaultChecked={active}
                    onChange={(event) => {
                      setActive(event.target.checked);
                    }}
                    style={{ backgroundColor: "#d6dae6" }}
                  />
                </div>
              </div>

              <div className="form-group row justify-content-center">
                <div className="col-6">
                  <button
                    type="button"
                    style={{
                      backgroundColor: "#4cabd4",
                      borderRadius: "20px",
                    }}
                    className="btn btn-primary btn-block"
                    onClick={() => {
                      onAddButtonClick();
                    }}
                  >
                    Add New User
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  );
};
const ColoredLine = ({ color }) => (
  <hr
    style={{
      color: color,
      backgroundColor: color,
      height: 1,
    }}
  />
);

const UpdateUserModal = (props) => {
  const newUserModalState = useSelector(getUpdateUserModelStatus);
  const updateUser = useSelector(getUpdateUserSelected);

  return (
    <Modal
      size="md"
      isOpen={newUserModalState}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "62vh",
          width: "50vw",
          position: "absolute",
          top: "15vh",
          left: "25vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      <UpdateUser
        brokerageCode={props.brokerageCode}
        user={updateUser}
        brokerageAddressList={props.brokerageAddressList}
      ></UpdateUser>
    </Modal>
  );
};

const UpdateUser = (updateUser) => {
  const user = updateUser.user;
  console.log("updated suer", user);
  const updateErrors = useSelector(getUpdateErrors);
  const [selecteduser, setSelecteduser] = useState({
    uName: user.firstname + " " + user.lastname,
    uEmail: user.user.email,
    uContact: user.phonenumber,
    uLocation: user.location
      ? user.location
      : user.brokerages[0]
      ? user.brokerages[0].address[0] || user.brokerages[0].address
        ? user.brokerages[0].address[0]
          ? user.brokerages[0].address[0].city
          : user.brokerages[0].address.city
        : ""
      : "",
    uRole: user.jobrole,
    uBiography: user.bio,
    uActive: user.isactive,
    uAdmin: user.isadmin,
    uId: user._id,
    uPermissions: user.permissions || [],
    uProspectPermissions: user.brokerProspectsPermissions || [],
    languagePreference: user.languagepreference,
  });
  const dispatch = useDispatch();
  const onLocantionChangeHandler = (values) => {
    setSelecteduser({
      ...selecteduser,
      uLocation: values[0].value,
    });
  };
  let userList = useSelector(getUserInformation);
  return (
    <PerfectScrollbar>
      <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
        <div className="row ml-1 p-3">
          <div>
            <span
              className="text-center"
              style={{ fontFamily: "GibsonSemiBd", fontSize: "17px" }}
            >
              Update User
            </span>
          </div>

          <div
            className="ml-auto"
            style={{ marginTop: "-15px", marginRight: "-10px" }}
          >
            <CancelIcon
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => {
                dispatch(toggleUpdateUserModel(false));
              }}
            ></CancelIcon>
          </div>
        </div>

        <div
          className="row pt-3  justify-content-center"
          style={{
            fontFamily: "GibsonRegular",
          }}
        >
          <div className="col-8">
            <form noValidate>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Name</label>
                <div className="col-sm-9">
                  <input
                    autoFocus
                    type="text"
                    id="uName"
                    name="uName"
                    className="form-control"
                    placeholder="Enter Name"
                    defaultValue={user.firstname + " " + user.lastname}
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setSelecteduser({
                        ...selecteduser,
                        uName: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Email</label>
                <div className="col-sm-9">
                  <input
                    type="email"
                    id="uEmail"
                    name="uEmail"
                    className="form-control"
                    placeholder="Enter Email"
                    defaultValue={user.user.email}
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setSelecteduser({
                        ...selecteduser,
                        uEmail: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Contact</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    id="uContact"
                    name="uContact"
                    className="form-control"
                    placeholder="Enter Contact"
                    defaultValue={user.phonenumber}
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setSelecteduser({
                        ...selecteduser,
                        uContact: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Location</label>
                <div className="col-sm-9">
                  <Select
                    id="uLocation"
                    name="uLocation"
                    color={theme.COLORS.primary_navyblue}
                    options={updateUser.brokerageAddressList.map(
                      ({ addr_line1, city, postal_code }) => ({
                        value: addr_line1 + " " + city + " " + postal_code,
                        label: addr_line1 + " " + city + " " + postal_code,
                      })
                    )}
                    placeholder={selecteduser ? selecteduser.uLocation : ""}
                    onChange={(values) => onLocantionChangeHandler(values)}
                    style={{
                      width: "100%",
                      height: "6vh",
                      fontSize: "1.9vmin",
                      border: "5px solid white",
                      borderRadius: 15,
                      fontFamily: "GibsonRegular",
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Role / Job title
                </label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    id="uRole"
                    name="uRole"
                    className="form-control"
                    placeholder="Enter Role/Job title"
                    defaultValue={user.jobrole}
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setSelecteduser({
                        ...selecteduser,
                        uRole: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Biography (max 250 chars)
                </label>
                <div className="col-sm-9">
                  <textarea
                    type="text"
                    id="uBiography"
                    name="uBiography"
                    rows="3"
                    className="form-control"
                    placeholder="Enter Biography (max 250 chars)"
                    defaultValue={user.bio}
                    style={{ backgroundColor: "#d6dae6" }}
                    onChange={(event) => {
                      setSelecteduser({
                        ...selecteduser,
                        uBiography: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 form-check-label">
                  {" "}
                  Language Preference
                </label>
                <div className="col-sm-9">
                  <ReactSelect
                    defaultValue={[
                      { value: "fr", label: "French" },
                      { value: "en", label: "English" },
                    ].find(
                      (option) => option.value === user.languagepreference
                    )}
                    name="languagePreference"
                    options={[
                      {
                        value: "fr",
                        label: "French",
                      },
                      {
                        value: "en",
                        label: "English",
                      },
                    ]}
                    onChange={(option) => {
                      setSelecteduser({
                        ...selecteduser,
                        languagePreference: option,
                      });
                    }}
                    // className="basic-multi-select"
                    // classNamePrefix="select"
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 form-check-label">Admin</label>
                <div className="col-sm-9">
                  <input
                    className="form-check-input ml-0"
                    type="checkbox"
                    id="isUAdmin"
                    name="isUAdmin"
                    defaultChecked={user.isadmin}
                    onChange={(event) => {
                      setSelecteduser({
                        ...selecteduser,
                        uAdmin: event.target.checked,
                      });
                    }}
                    style={{ backgroundColor: "#d6dae6" }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 form-check-label">Active</label>
                <div className="col-sm-9">
                  <input
                    className="form-check-input ml-0"
                    type="checkbox"
                    id="isUActive"
                    name="isUActive"
                    defaultChecked={user.isactive}
                    onChange={(event) => {
                      setSelecteduser({
                        ...selecteduser,
                        uActive: event.target.checked,
                      });
                    }}
                    style={{ backgroundColor: "#d6dae6" }}
                  />
                </div>
              </div>
              <div className="form-group row" style={{'display': selecteduser.uActive ? 'none': 'flex' }}>
                <label className="col-sm-3 form-check-label">Transfer prospects to a different user</label>
                <div className="col-sm-9">
                  <input
                    className="form-check-input ml-0"
                    id="isUTransfer"
                    name="isUTransfer"
                    onChange={(e) => {
                      let selectedUser = e.target.value;
                      const brokerInfo = userList.find(
                        (broker) => `${broker.firstname} ${broker.lastname}` === selectedUser
                      );
                      if(brokerInfo){
                        setSelecteduser({
                          ...selecteduser,
                          uTransfer: brokerInfo._id,
                        });
                      }
                    }}
                    list="otherusers"
                    style={{ backgroundColor: "#d6dae6" }}                    
                  />
                  <datalist id="otherusers">
                    {userList.map(broker => {
                      return (
                        <option 
                          key={broker._id} 
                          value={`${broker.firstname} ${broker.lastname}`}>
                        </option>
                      )
                    })}
                  </datalist>
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 form-check-label">Permissions</label>
                <div className="col-sm-9">
                  <ReactSelect
                    defaultValue={user.permissions ? user.permissions : []}
                    isMulti
                    name="permissions"
                    options={[
                      { value: "goToMarket", label: "Able to go to market" },
                      { value: "bind", label: "Able to bind" },
                    ]}
                    onChange={(option) => {
                      // setSelectedOption(option);
                      // getAddInsurerStatus(option.value);
                      // setSelectedInsurerName(option.label);
                      console.log("tables", option);
                      console.log("lokkd the the users", user);
                      setSelecteduser({
                        ...selecteduser,
                        uPermissions: option,
                      });
                    }}
                    // className="basic-multi-select"
                    // classNamePrefix="select"
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 form-check-label">
                  {" "}
                  Prospects Permissions
                </label>
                <div className="col-sm-9">
                  <ReactSelect
                    defaultValue={
                      user.brokerProspectsPermissions
                        ? user.brokerProspectsPermissions
                        : []
                    }
                    isMulti
                    name="brokerProspectsPermissions"
                    options={[
                      {
                        value: "AllProspects",
                        label: "Able to view all prospects",
                      },
                    ]}
                    onChange={(option) => {
                      setSelecteduser({
                        ...selecteduser,
                        uProspectPermissions: option,
                      });
                    }}
                    // className="basic-multi-select"
                    // classNamePrefix="select"
                  />
                </div>
              </div>

              <div className="form-group row justify-content-center">
                <div className="col-6">
                  <button
                    type="button"
                    style={{
                      backgroundColor: "#4cabd4",
                      borderRadius: "20px",
                    }}
                    className="btn btn-primary btn-block"
                    onClick={() => {
                      let code = { brokerage_code: updateUser.brokerageCode };
                      let data = {
                        name: selecteduser.uName,
                        email: selecteduser.uEmail,
                        contact: selecteduser.uContact,
                        location: selecteduser.uLocation,
                        isactive: selecteduser.uActive,
                        isadmin: selecteduser.uAdmin,
                        brokerage_code: updateUser.brokerageCode,
                        jobrole: selecteduser.uRole,
                        bio: selecteduser.uBiography,
                        id: selecteduser.uId,
                        permissions: selecteduser.uPermissions,
                        brokerProspectsPermissions:
                          selecteduser.uProspectPermissions,
                        languagePreference: selecteduser.languagePreference,
                      };
                      if(selecteduser.uTransfer){
                        data.transfer = selecteduser.uTransfer
                      }
                      console.log(data);
                      dispatch(updateDetails(data))
                        .then(
                          setTimeout(() => {
                            dispatch(toggleUpdateUserModel(false));
                          }, 100)
                        )
                        .then(
                          setTimeout(() => {
                            dispatch(getUserDetails(code));
                            Array.isArray(updateErrors) && !updateErrors.length
                              ? toast.success("User Details Updated")
                              : toast(updateErrors);
                          }, 1000)
                        );
                    }}
                  >
                    Update
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  );
};

export default BrokerageSuperAdminUserManagement;
